/**
 * Collections hero: horizontal scroll via prev/next arrows, dots reflect scroll position.
 * Also handles variant pill selection (updates hidden input for add to cart).
 */
function initCollectionsHero(section) {
  const track = section.querySelector('[data-collections-track]');
  const prevBtn = section.querySelector('[data-collections-prev]');
  const nextBtn = section.querySelector('[data-collections-next]');
  const dotsContainer = section.querySelector('[data-collections-dots]');
  const dots = section.querySelectorAll('[data-collections-dot]');
  const cards = section.querySelectorAll('[data-collections-card]');

  if (!track) return;

  const gap = 16;
  const cardWidth = cards.length > 0 ? cards[0].offsetWidth : 280;
  const step = cardWidth + gap;

  function getMaxScroll() {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function updateDots() {
    if (dots.length === 0) return;
    const maxScroll = getMaxScroll();
    if (maxScroll <= 0) {
      dots.forEach((d, i) => {
        d.classList.toggle('collections-hero__dot--active', i === 0);
        d.setAttribute('aria-selected', i === 0);
      });
      return;
    }
    const numDots = dots.length;
    const scrollLeft = track.scrollLeft;
    const index = Math.min(Math.floor((scrollLeft / maxScroll) * numDots), numDots - 1);
    dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('collections-hero__dot--active', active);
      dot.setAttribute('aria-selected', active);
    });
  }

  function scrollBy(direction) {
    const next = direction === 'next'
      ? track.scrollLeft + step
      : track.scrollLeft - step;
    track.scrollTo({ left: Math.max(0, Math.min(next, getMaxScroll())), behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', () => scrollBy('prev'));
  if (nextBtn) nextBtn.addEventListener('click', () => scrollBy('next'));

  track.addEventListener('scroll', updateDots);
  window.addEventListener('resize', () => {
    updateDots();
  });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      const maxScroll = getMaxScroll();
      if (maxScroll <= 0) return;
      const numDots = dots.length;
      const target = numDots > 1 ? (i / (numDots - 1)) * maxScroll : 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    });
    dot.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        dot.click();
      }
    });
  });

  updateDots();
}

function initVariantPills(section) {
  section.querySelectorAll('[data-variants-wrap]').forEach((wrap) => {
    const card = wrap.closest('[data-collections-card]');
    if (!card) return;
    const input = card.querySelector('[data-variant-input]');
    const addButton = card.querySelector('.collections-hero__add-button');
    const pills = wrap.querySelectorAll('[data-variant-pill]');
    pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (pill.disabled) return;
        const variantId = pill.getAttribute('data-variant-id');
        const available = pill.getAttribute('data-variant-available') === 'true';
        if (!variantId || !input) return;
        input.value = variantId;
        pills.forEach((p) => p.classList.remove('collections-hero__variant-pill--active'));
        pill.classList.add('collections-hero__variant-pill--active');
        if (addButton) {
          addButton.disabled = !available;
          const soldOutText = addButton.getAttribute('data-sold-out-text');
          const addText = addButton.getAttribute('data-add-text');
          if (soldOutText !== null && addText !== null) {
            addButton.textContent = available ? addText : soldOutText;
          }
        }
      });
    });
  });
}

function initCollectionsHeroSections() {
  document.querySelectorAll('[data-collections-hero]').forEach((section) => {
    initCollectionsHero(section);
    initVariantPills(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionsHeroSections);
} else {
  initCollectionsHeroSections();
}
